import { Box, Text } from "@chakra-ui/react";

const ProgressBar = ({ value, color, height }) => {
  return (
    <Box overflow="hidden" position="relative" bg="transparent" m="5px 0" display="flex" alignItems="center">
      <Box
        display="flex"
        alignItems="center"
        role="progressbar"
        aria-valuemax="100"
        aria-valuemin="0"
        aria-valuenow={value}
        minWidth={9}
        width={`${value > 0 ? value : 10}%`}
        height={height || 5}
        bg={color}
        borderRadius="full"
      >
      </Box>
      <Box minWidth={7} m="0 0 0 5px">
        <Text fontSize="10px" fontWeight="800">
          {`${value}%`}
        </Text>
      </Box>
    </Box>
  );
};

export default ProgressBar;
